import { defineAction } from '~/prix'
import variableListAction from './variableList.action.json' with { type: 'json' }
import { z } from 'zod'
import { VariableWithConclusion } from '../variables.typing'

const variableWithConclusionSchema = z.custom<VariableWithConclusion>()

const variableListDefinition = defineAction({
  ...variableListAction,

  input: z.object({
    search: z.string().trim().optional(),
    category: z.string().trim().optional(),
    startIndex: z.number().min(0).optional(),
    endIndex: z.number().min(1).optional(),
    preferredSpaceDelimitationType: z.string().trim().optional(),
    preferredSpaceDelimitationId: z.number().min(0).optional(),
  }),
  output: z.object({
    items: z.array(variableWithConclusionSchema).optional(),
    pagesLeft: z.number().optional(),
    variablesCount: z.number().optional(),
  }),

  cache: input => {
    if (
      input.search ||
      !input.preferredSpaceDelimitationType ||
      typeof input.preferredSpaceDelimitationId !== 'number'
    ) {
      return {}
    }

    return {
      back: {
        // 2 days
        expirationMsForFallback: 1000 * 60 * 60 * 24 * 2,
        // 5 minutes
        expirationMsForUpdate: 1000 * 60 * 5,
      },
      front: {
        // 5 days
        expirationMsForFallback: 1000 * 60 * 60 * 24 * 5,
        // 5 minutes
        expirationMsForUpdate: 1000 * 60 * 5,
      },
    }
  },
})

export default variableListDefinition
